var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.625 17C27.625 22.868 22.868 27.625 17 27.625C11.132 27.625 6.375 22.868 6.375 17C6.375 11.132 11.132 6.375 17 6.375C22.868 6.375 27.625 11.132 27.625 17ZM29.75 17C29.75 24.0417 24.0417 29.75 17 29.75C9.95837 29.75 4.25 24.0417 4.25 17C4.25 9.95837 9.95837 4.25 17 4.25C24.0417 4.25 29.75 9.95837 29.75 17ZM13.2812 14.875C14.1615 14.875 14.875 14.1615 14.875 13.2812C14.875 12.401 14.1615 11.6875 13.2812 11.6875C12.401 11.6875 11.6875 12.401 11.6875 13.2812C11.6875 14.1615 12.401 14.875 13.2812 14.875ZM22.3125 13.2812C22.3125 14.1615 21.5989 14.875 20.7188 14.875C19.8386 14.875 19.125 14.1615 19.125 13.2812C19.125 12.401 19.8386 11.6875 20.7188 11.6875C21.5989 11.6875 22.3125 12.401 22.3125 13.2812ZM17 21.25C14.4193 21.25 12.75 19.6139 12.75 18.0625H10.625C10.625 21.2055 13.7127 23.375 17 23.375C20.2874 23.375 23.375 21.2055 23.375 18.0625H21.25C21.25 19.6139 19.5807 21.25 17 21.25Z",
    fill: "#24A36C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.ec78b55d360564d773308d45da781891.svg";
export { ForwardRef as ReactComponent };